import React from 'react';
import { Link } from 'react-router-dom';
import './Banner.css'; 
import thumbnail from '../../assets/images/work/banner/thumbnail.jpg';
import sakura from '../../assets/images/work/banner/sakura.png';
import sakura_2 from '../../assets/images/work/banner/sakura_2.png';
import apparel from '../../assets/images/work/banner/apparel.png';
import job_change from '../../assets/images/work/banner/job_change.png';
import seminar from '../../assets/images/work/banner/seminar.png';
import isome from '../../assets/images/work/banner/isome.png';
import cat_event from '../../assets/images/work/banner/cat_event.png';
import yoga from '../../assets/images/work/banner/yoga.png';

function Banner() {
  
    return (
      <main className="banner_main">
      <div className="banner_container">
        <img src={thumbnail} alt="バナー集のサムネイル画像です。" className="banner_thumbnail" />

        <div className="back-to-home-banner">
          <Link to="/" className="back-link">← Homeへ戻る</Link>
        </div>

        <p className="lead_text">自主制作で取り組んだバナーをまとめています。まだ数は少ないですが、様々なジャンルのバナーに取り組み、デザインの引き出しを広げらるよう努めています。</p>
       
        <section className="banner_content">
          {/*さくらインターネットバナー*/}
          <div className="banner_box">
            <div className="banner_img_area">
              <img src={sakura_2} alt="レンタルサーバーのバナー画像" className="banner_img" />
            </div>
            <div className="banner_info">
              <div className="info_set">
                <h2 className="info_title">ターゲット層</h2>
                <div className="info_text">主にWeb初心者・個人ユーザー、ブログや趣味のサイトを作りたい人</div>
              </div>
              <div className="info_set">
                <h2 className="info_title">デザインのポイント</h2>
                <p className="info_text">右下の「129円〜」の大きな文字で価格の安さを強調し、「容量10GB〜」「56万件突破」といった実績情報で安心感を演出。ブラウザ風のアイコンや画像のイラストを使うことで、「Webサイトを作るサービス」であることを視覚的に伝え、最後に、「今すぐ14日間無料お試し」のCTAボタンを強調し、すぐに行動してもらえるような導線にした。</p>
              </div> 
            </div>
          </div>
          {/*さくらインターネットバナー*/}
          <div className="banner_box">
            <div className="banner_img_area">
              <img src={sakura} alt="採用バナー画像" className="banner_img" />
            </div>
            <div className="banner_info">
              <div className="info_set">
                <h2 className="info_title">ターゲット層</h2>
                <div className="info_text">20〜30代の若手〜中堅社会人層で、特に働き方や自己成長に関心が高い転職希望者</div>
              </div>
              <div className="info_set">
                <h2 className="info_title">デザインのポイント</h2>
                <p className="info_text">笑顔の女性を大きく配置し、「働きやすさ」や「充実感」のある企業イメージを視覚的に表現。下部には企業ロゴだけでなく、募集職種を複数並べることで、多様な職種を募集していることをアピールし、CTAへ誘導している。バナーを囲むフレームは企業ロゴの曲線をモチーフとしており、自社の価値観や「人と人が支え合いながら共に成長していく」という企業の思いを間接的に表現した。</p>
              </div> 
            </div>
          </div>

          {/*アパレルバナー*/}
          <div className="banner_box">
            <div className="banner_img_area">
              <img src={apparel} alt="アパレルバナー画像" className="banner_img" />
            </div>
            <div className="banner_info">
              <div className="info_set">
                <h2 className="info_title">ターゲット層</h2>
                <div className="info_text">20代～30代の女性を中心とした、ファッションに敏感で、シンプルかつ洗練されたテイストを好む層</div>
              </div>
              <div className="info_set">
                <h2 className="info_title">デザインのポイント</h2>
                <p className="info_text">淡いグリーンをベースにした背景と、アクセントの桜の花びらで春らしさや柔らかさを演出し、季節感を直感的に表現。重要度の高い「SALE」と「70%」は太字やフォントを変えて強調させた。
                </p>
              </div> 
            </div>
          </div>

          {/*転職バナー*/}
          <div className="banner_box">
            <div className="banner_img_area">
              <img src={job_change} alt="転職バナー画像" className="banner_img" />
            </div>
            <div className="banner_info">
      
              <div className="info_set">
                <h2 className="info_title">ターゲット層</h2>
                <div className="info_text">キャリアアップや年収アップを目的に転職を考える30代〜40代のビジネスパーソン</div>
              </div>
              <div className="info_set">
                <h2 className="info_title">デザインのポイント</h2>
                <p className="info_text">転職を踏み出せずにいる人を後押しするような強いフレーズで目線を惹きつけ、続けて充実したサポートや実績をアピール。はみ出す文字で溢れる感情を表現しつつ、男性の真剣で前向きな表情で決意や挑戦を直感的に伝えるようにした。深みのある青で「信頼感」や「ハイキャリア向け」の転職サービスであることを表現した。</p>
              </div> 
            </div>
          </div>

          {/*セミナーバナー*/}
          <div className="banner_box">
            <div className="banner_img_area">
              <img src={seminar} alt="セミナーバナー画像" className="banner_img" />
            </div>
            <div className="banner_info">
              
              <div className="info_set">
                <h2 className="info_title">ターゲット層</h2>
                <div className="info_text">AI技術の導入やDX推進に関心が高いビジネスパーソン（20～40代）、特に企業の経営者層・管理職、IT担当者</div>
              </div>
              <div className="info_set">
                <h2 className="info_title">デザインのポイント</h2>
                <p className="info_text">イベントの内容が最先端の技術に触れたものなので、寒色を用いたグラデーションや幾何学的な模様で近未来感を演出。トレンドのキーワードである「生成AI」の部分を強調。人物を大きく配置し、重要な情報である「誰」がトークするイベントなのかをアピールした。</p>
              </div> 
            </div>
          </div>

          {/*アイソメバナー*/}
          <div className="banner_box">
            <div className="banner_img_area">
              <img src={isome} alt="業務効率ツールバナー画像" className="banner_img" />
            </div>
            <div className="banner_info">
              
              <div className="info_set">
                <h2 className="info_title">ターゲット層</h2>
                <div className="info_text">業務に追われ、頭を抱える20〜40代のビジネスパーソン（特にデスクワーク中心の職種）</div>
              </div>
              <div className="info_set">
                <h2 className="info_title">デザインのポイント</h2>
                <p className="info_text">メリットの「50%」削減は特にフォントサイズを大きく設定し、明確に強調。イラストで人物が両手をあげて喜んでいるポーズにより達成感や、満足感、成功体験を連想させ、このサービスを導入することのメリットを感情的に伝えるようにした。</p>
              </div> 
            </div>
          </div>

          {/*猫イベントバナー*/}
          <div className="banner_box">
            <div className="banner_img_area">
              <img src={cat_event} alt="猫イベントバナー画像" className="banner_img" />
            </div>
            <div className="banner_info">
              
              <div className="info_set">
                <h2 className="info_title">ターゲット層</h2>
                <div className="info_text">猫好きで、可愛いものや癒しを求める10～30代の女性</div>
              </div>
              <div className="info_set">
                <h2 className="info_title">デザインのポイント</h2>
                <p className="info_text">ピンクをベースカラーに使用し、柔らかく可愛らしいイメージを演出。猫の足跡の装飾や手書き風フォントでイベントの楽しげな雰囲気が伝わるようにした。また、猫のイベントの主役である「猫」ちゃんを大きく配置し、イベントの開催日時や場所は左下にコンパクトにまとめた。メインビジュアルである猫様の邪魔にならないようにした。</p>
              </div> 
            </div>
          </div>

          {/*ヨガバナー*/}
          <div className="banner_box">
            <div className="banner_img_area">
              <img src={yoga} alt="ヨガバナー画像" className="banner_img" />
            </div>
            <div className="banner_info">
              
              <div className="info_set">
                <h2 className="info_title">ターゲット層</h2>
                <div className="info_text">20〜40代の健康や美容、自己投資に関心が高い女性</div>
              </div>
              <div className="info_set">
                <h2 className="info_title">デザインのポイント</h2>
                <p className="info_text">淡く温かみのあるグラデーション背景で、落ち着きや癒しを演出し、ヨガのリラックス効果を表現。明朝体を使用し、エレガントで女性的な印象を強調した。</p>
              </div> 
            </div>
          </div>

        </section>

      <div className="back-to-home-banner">
          <Link to="/" className="back-link">← Homeへ戻る</Link>
      </div>  
         
      </div>

      </main>
    );
    
  }
  
  export default Banner;